import getShopId from '@core/reducers/shop/selectors/getShopId';
import getGroceriesTabSelected from '@shopDetails/selectors/getGroceriesTabSelected';
import { getSectionDetailsOrigin } from '@conversion/tracking/utils';
import getMenu from '@core/reducers/menu/selectors/getMenu';
import { track, logError } from '@tracking';
import { NOT_SET } from '@utils/tracking/constants';
import { SECTION_TYPE, SUGGESTED } from '../constants';

const EVENT_NAME = 'section_details.loaded';

function getSectionImageType(sectionType) {
  if (sectionType && sectionType === SUGGESTED) {
    return SECTION_TYPE.MATCHED;
  }
  if (sectionType && sectionType === SECTION_TYPE.PAID) {
    return SECTION_TYPE.BRANDED;
  }
  if (sectionType && sectionType === SECTION_TYPE.DEFAULT) {
    return SECTION_TYPE.DEFAULT.toLowerCase();
  }
  return NOT_SET;
}

const trackSectionDetailsLoaded = ({ sectionId, origin, sectionType }) => (
  dispatch,
  getState,
) => {
  try {
    const state = getState();
    const shopId = getShopId(state);
    const menu = getMenu(state);

    let shopItemsQuantity = NOT_SET;
    let productCategory = NOT_SET;
    let productCategoryIndex = NOT_SET;
    let sectionDetailsOrigin = getGroceriesTabSelected(state);
    const sectionImageType = getSectionImageType(sectionType);

    const section = menu?.sections?.find(x => x.id === sectionId);
    if (section) {
      shopItemsQuantity = `${section.products.length},${section.totalProducts}`;
      productCategory = section.name;
      productCategoryIndex = menu?.sections.indexOf(section);
      sectionDetailsOrigin =
        origin || getSectionDetailsOrigin(sectionDetailsOrigin);
    }

    const payload = {
      shopId,
      shopItemsQuantity,
      productCategory,
      productCategoryIndex,
      sectionDetailsOrigin,
      sectionImageType,
    };

    track(EVENT_NAME, payload);
  } catch (error) {
    logError(EVENT_NAME, error);
  }
};

export default trackSectionDetailsLoaded;
